import { PageBreak, Paragraph, TextRun, HeadingLevel } from 'docx'
import SectionHeader from '../../SectionHeader'
import { formatYearMonth } from '../../../ReportPDF/TaiwanDateConvert'

const Chapter4Sub5Page = ({ reportData }) => {
  const { reprotDao } = reportData || {}
  const { companyName, campaignStartDate } = reprotDao || {}

  return [
    new Paragraph({ children: [new PageBreak()] }),
    new Paragraph(''),
    SectionHeader({
      text: '4.4 受測者釣中行為清單',
      size: 48,
      headingNumber: HeadingLevel.HEADING_2,
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: ' ',
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '依據受測者演練之釣中行為，詳列之「瀏覽郵件」與「點閱連結」與「開啟附件」等受清單。',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: ' ',
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: `請查閱附件：${companyName}_社交工程郵件演練服務結果_各類清單_${formatYearMonth(
            campaignStartDate,
          )}.xlsx`,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: ' ',
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '■ 	',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 16,
        }),
        new TextRun({
          text: `頁籤資訊-${companyName}_釣中清單`,
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: ' ',
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '■ 	',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 16,
        }),
        new TextRun({
          text: '頁籤資訊-瀏覽郵件 點閱連結 開啟附件_結果清單',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      children: [
        new TextRun({
          text: ' ',
          size: 24,
        }),
      ],
    }),
    new Paragraph({
      style: 'textParagraph',
      children: [
        new TextRun({
          text: '■ 	',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 16,
        }),
        new TextRun({
          text: '頁籤資訊-部門釣中_結果清單',
          font: { name: 'Microsoft JhengHei', eastAsia: 'Microsoft JhengHei' },
          size: 24,
        }),
      ],
    }),
  ]
}

export default Chapter4Sub5Page
